import axios from 'axios'

export const WarningBannerService = {
  async getWarningBanner() {
    const { data } = await axios.get('/api/warningBanner')
    return data
  },
}
